export default "__VITE_ASSET__DtIrT1hY__"